import React from "react";
import Image from "./keller-logo-2016.png";
import "./style.scss";
import { useHistory } from "react-router";

export const KellerLogo = () => {
  const history = useHistory();
  return (
    <img
      onClick={(e) => history.push("")}
      className="kserv-keller-logo"
      src={Image}
      alt="Keller"
    />
  );
};
